
<template lang="pug">
v-card.flexcard
  v-card-actions.justify-center
    v-btn(dark='' color='#3C5A99' @click='post_facebook')
      img(src='https://www.gstatic.com/images/icons/material/system/2x/post_facebook_white_18dp.png')
      |  Share on Facebook
</template>

<script>
export default {
  props: {
    facebookStub: {
      type: String
    },
    facebookRedirect: {
      type: String
    }
  },
  data() {
      return {};
  },
  methods: {
    post_facebook() {
      let encoded_stub = encodeURIComponent(this.facebookStub)
      let encoded_redirect = encodeURIComponent(this.facebookRedirect)
      window.open(
        `https://www.facebook.com/dialog/share?app_id=498653990882551&display=popup&href=${encoded_redirect}&redirect_uri=&quote=${encoded_stub}&hashtag=#SupportOurStudents`,
        "_blank"
      );
    }
  }
};
</script>
